var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleButton',{staticClass:"toggle-switch",class:_vm.toggleType,attrs:{"value":_vm.value,"sync":true,"css-colors":true,"labels":_vm.labels,"disabled":_vm.disabled},on:{"input":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }